import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlphartis = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 500 500",
	width: 500,
	height: 500,
	...props,
	children: [/* @__PURE__ */ _jsx("style", { children: "\n		.s0 { fill: currentColor } \n	" }), /* @__PURE__ */ _jsx("g", {
		id: "Logo",
		children: /* @__PURE__ */ _jsx("path", {
			id: "<Path>",
			className: "s0",
			d: "m250.4 54.5l-244.9 245.4v146.4h146.2l98.7-99 98.8 99h146.1v-146.4l-244.9-245.5z"
		})
	})]
});
export default SvgAlphartis;
